import ContractBadge from './ContractBadge';

export default ContractBadge;
